import searchplaceByGeoCode from 'shared/utils/searchPlacByGeocode';
import fetchAddressFromGeoCode from 'shared/utils/fetchAddressFromGeoCode';
import { RawMaterialProps } from 'enums/RawMaterialEnums';

export const searchPlaceByCountryProvince = async (
    country: string,
    province: string,
    setFieldValue: (
        field: string,
        value?: string | number,
        shouldValidate?: boolean | undefined
    ) => void,
    index?: number,
    setFetchingAddress?: (value: boolean) => void
) => {
    try {
        setFetchingAddress?.(true);
        const results: google.maps.GeocoderResult[] | undefined =
            await searchplaceByGeoCode(`${province} ${country}`);
        if (results && results!.length > 0 && results![0]) {
            const latling = results![0].geometry.location;
            const addressComponents = results![0].address_components;
            const formattedAddress = results![0].formatted_address;
            setFieldValue(`${RawMaterialProps.MAP}`, formattedAddress);
            setAddressInState(addressComponents, latling, setFieldValue, index);
        }
    } catch (error) {
        console.error('error is ', error);
    } finally {
        setFetchingAddress?.(false);
    }
};

export const setAddressInState = (
    addressComponents: google.maps.GeocoderAddressComponent[],
    latling: google.maps.LatLng | null,
    setFieldValue: (
        field: string,
        value?: string | number,
        shouldValidate?: boolean | undefined
    ) => void,
    index?: number
) => {
    const { streetLocality, country, province, city, pinCode } =
        fetchAddressFromGeoCode(addressComponents);
    if (streetLocality.trim() === '') {
        setFieldValue(
            `${RawMaterialProps.ADDRESS}.${index}.${RawMaterialProps.ADDRESS}.${RawMaterialProps.STREET}`,
            ''
        );
    } else {
        setFieldValue(
            `${RawMaterialProps.ADDRESS}.${index}.${RawMaterialProps.ADDRESS}.${RawMaterialProps.STREET}`,
            streetLocality?.trim() ?? ''
        );
    }

    setFieldValue(
        `${RawMaterialProps.ADDRESS}.${index}.${RawMaterialProps.ADDRESS}.${RawMaterialProps.COUNTRY}`,
        country?.long_name ?? ''
    );
    setFieldValue(
        `${RawMaterialProps.ADDRESS}.${index}.${RawMaterialProps.ADDRESS}.${RawMaterialProps.COUNTRY_CODE}`,
        country?.short_name ?? ''
    );
    setFieldValue(
        `${RawMaterialProps.ADDRESS}.${index}.${RawMaterialProps.ADDRESS}.${RawMaterialProps.PROVINCE}`,
        province?.long_name ?? ''
    );
    setFieldValue(
        `${RawMaterialProps.ADDRESS}.${index}.${RawMaterialProps.ADDRESS}.${RawMaterialProps.CITY}`,
        city?.long_name ?? ''
    );
    setFieldValue(
        `${RawMaterialProps.ADDRESS}.${index}.${RawMaterialProps.ADDRESS}.${RawMaterialProps.POSTAL_CODE}`,
        pinCode?.long_name ?? ''
    );
    setFieldValue(
        `${RawMaterialProps.ADDRESS}.${index}.${RawMaterialProps.ADDRESS}.${RawMaterialProps.LATITUDE}`,
        latling?.lat()
    );
    setFieldValue(
        `${RawMaterialProps.ADDRESS}.${index}.${RawMaterialProps.ADDRESS}.${RawMaterialProps.LONGITUDE}`,
        latling?.lng()
    );
    setFieldValue(
        `${RawMaterialProps.ADDRESS}.${index}.${RawMaterialProps.INGREDIENT_ORIGIN}`,
        `${province?.long_name ? province?.long_name + ',' : ''}${country?.long_name
        }`
    );
}; 